import { getJsonAsync, GetApiDataWithCondition } from './fetchConfig';

export const getStatesList = (countryCode, shouldFetch) => {
  return GetApiDataWithCondition('provinces/' + countryCode, shouldFetch);
};

export const getStatesPromise = (country) =>
  getJsonAsync('provinces/' + country.twoLetterCountryCode);
